module.exports = ".nav-link {\n\tcolor: #7dc873;\n}\n\n.nav-link:focus, .nav-link:hover {\n\tcolor: #64a45c;\n}"